/* global Sentry */

LS = {
	state: {
		cropped: false
	},
	stash: {
		fetch: [],
		maps: []
	},
	formats: {
		sales: {
			label: 'Sale',
			heading: 'Land for sale',
			acquire: 'buy',
			acquiring: 'buying',
			dispose: 'sell',
			disposing: 'selling',
			price: 'list price'
		},
		leases: {
			label: 'Lease',
			heading: 'Land for lease',
			acquire: 'lease',
			acquiring: 'leasing',
			dispose: 'lease',
			disposing: 'leasing',
			price: 'lease rate'
		},
		auctions: {
			label: 'Auction',
			heading: 'Land auctions',
			acquire: 'buy',
			acquiring: 'buying',
			dispose: 'auction',
			disposing: 'auctioning',
			price: 'minimum bid'
		}
	},
	types: {
		residential: 'Residential',
		commercial: 'Commercial',
		agricultural: 'Agricultural',
		recreational: 'Recreational'
	},
	criteria: {
		'Geography': {
			'beachfront': 'Beachfront',
			'desert': 'Desert',
			'island': 'Island',
			'lakefront': 'Lake property',
			'mountain': 'Mountain',
			'off-grid': 'Off-grid',
			'resort': 'Resort',
			'riverfront': 'River property',
			'rural': 'Rural',
			'waterfront': 'Waterfront'
		},
		'Land use': {
			'cattle-ranch': 'Cattle ranch',
			'chicken-farm': 'Chicken farm',
			'dairy-farm': 'Dairy farm',
			'development': 'Development',
			'homestead': 'Homestead',
			'industrial': 'Industrial',
			'investment': 'Investment',
			'mixed-use': 'Mixed-use',
			'organic-farm': 'Organic farm',
			'ranch': 'Ranch',
			'row-crop': 'Row crop',
			'rv-lot': 'RV lot',
			'hobby-farm': 'Small farm',
			'timberland': 'Timber'
		},
		'Structures': {
			'a-frame-house': 'A-frame house',
			'barn': 'Barn',
			'barndominium': 'Barndominium',
			'bunker': 'Bunker',
			'cabin': 'Cabin',
			'cottage': 'Cottage',
			'farm-house': 'Farm house',
			'house': 'House',
			'lodge': 'Lodge',
			'mobile-home': 'Mobile home',
			'tiny-home': 'Tiny home',
			'workshop': 'Workshop'
		},
		'Improvements': {
			'airstrip': 'Airstrip',
			'fenced': 'Fenced',
			'irrigated': 'Irrigated',
			'septic': 'Septic system',
			'solar-power': 'Solar power',
			'water-well': 'Water well'
		},
		'Features': {
			'cave': 'Cave',
			'creek': 'Creek',
			'mineral-rights': 'Mineral rights',
			'oil': 'Oil',
			'orchard': 'Orchard',
			'pasture': 'Pasture',
			'pond': 'Pond',
			'spring': 'Spring',
			'stream': 'Stream',
			'water-rights': 'Water rights',
			'waterfall': 'Waterfall',
			'wetland': 'Wetland',
			'wooded': 'Wooded',
			'vineyard': 'Vineyard'
		},
		'Activities': {
			'borders-public-land': 'Borders public land',
			'camping': 'Camping',
			'conservation': 'Conservation',
			'equestrian': 'Horse property',
			'fishing': 'Fishing',
			'golf-course-lot': 'Golfing',
			'hunting': 'Hunting',
			'waterfowl': 'Waterfowl'
		},
		'Attributes': {
			'by-owner': 'By owner',
			'cheap': 'Cheap',
			'distressed': 'Distressed',
			'historic': 'Historic',
			'new-construction': 'New construction',
			'owner-financing': 'Owner financed',
			'rent-to-own': 'Rent to own',
			'sustainable': 'Sustainable',
			'vacant': 'Undeveloped',
			'unrestricted': 'Unrestricted'
		}
	},
	directory: {
		agents: [],
		lenders: [],
		services: [
			'appraisal',
			'architecture',
			'auction',
			'consulting',
			'demolition',
			'energy',
			'engineering',
			'environmental',
			'equestrian',
			'equipment',
			'excavation',
			'fencing',
			'general-contracting',
			'home-building',
			'land-buying',
			'land-selling',
			'landscaping',
			'leasing',
			'legal',
			'management',
			'minerals',
			'oil-gas',
			'paving',
			'photography',
			'septic',
			'surveying',
			'timber',
			'well-drilling',
			'wildlife-management'
		]
	}
};

LS.tags = {};

Object.keys(LS.criteria).forEach(key => {
	Object.assign(LS.tags, LS.criteria[key]);
});

LS.log = {
	/**
	 * Create issue
	 *
	 * @param {String} message
	 * @param {String} [cause]
	 * @param {Object} [tags]
	 * @param {Object} [meta]
	 */
	issue(message, cause, tags, meta) {
		if (typeof Sentry === 'undefined') {
			return;
		}

		const data = {};

		if (meta) {
			data.contexts = {
				Meta: meta
			};
		}

		if (tags) {
			data.tags = tags;
		}

		if (cause instanceof Error) {
			cause.name = message;

			Sentry.captureException(cause, data);
		} else {
			Sentry.captureMessage(message + ': ' + (cause || 'No error message'), data);
		}
	},

	/**
	 * Create log
	 *
	 * @param {String} message
	 * @param {Object} [attributes]
	 */
	log(message, attributes = {}) {
		if (typeof Sentry === 'undefined') {
			return;
		}

		const fn = () => {
			Sentry.logger.info(message, attributes);
		};

		if (Sentry.logger) {
			fn();

			return;
		}

		window.debugQue.push(fn);

		Sentry.forceLoad();
	}
};

(() => {
	const parts = location.hostname.split('.');
	const ext = parts[2];
	const domain = `${parts[1]}.${ext}`;
	const pre = 'https://';

	$.env({
		production: () => ext === 'com',
		staging: () => ext === 'io'
	});

	$.merge({
		appUrl: `${pre}www.${domain}`,
		apiUrl: `${pre}api.${domain}/v1`,
		cdnUrl: `${pre}cdn.${domain}`,
		papiUrl: `${pre}papi.${domain}/v1`
	});
})();